var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 378,
    viewBox: "0 0 378 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4769_172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.25 378H194.355C92.4525 378 7.24503 300.825 0.472526 202.388C-3.30747 147.735 16.695 94.0277 55.2825 55.4402C94.0275 16.6952 147.735 -3.30731 202.388 0.472689C300.825 7.24519 378 92.4527 378 194.355V286.02C378 340.2 345.555 378.158 299.25 378.158V378Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4769_172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 378,
    height: 378,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalise);
export default __webpack_public_path__ + "static/media/balise.849bd02e5fe50c4977180b26dd8c20d3.svg";
export { ForwardRef as ReactComponent };